import http from '@/plugins/http'
import { Mensagens } from '@/plugins/constants'

export async function buscarUrl (id_unidade) {
  try {
    const { data } = await http.get(`/convert-mais/url/${id_unidade}`)
    return data
  } catch (erro) {
    if (erro.response.data.mensagem) {
      throw erro.response.data.mensagem
    }

    throw Mensagens.ERRO
  }
}
